import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {
  createStore, applyMiddleware,
  //  compose 
} from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap/dist/css/bootstrap.min.css';
import allReducers from './redux/reducers/index';
import WebFont from 'webfontloader';
import TagManager from 'react-gtm-module'
import {GTM} from './helpers/IDTags.js';

WebFont.load({
  google: {
    families: ['Barlow Condensed', 'Barlow Condensed:600i', 'Barlow Condensed:500i', 'Fjalla One', 'sans-serif'],
  }
});

const tagManagerArgs = {
  // gtmId: 'G-DL2DVTX1RL'//Tag Interamerican
  gtmId: GTM
}

TagManager.initialize(tagManagerArgs)

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  allReducers,
  // composeEnhancers(applyMiddleware(thunk))
  applyMiddleware(thunk)
);

ReactDOM.render(

  <Provider store={store}>
    <App />
  </Provider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
